import request from '@teetsh/app/src/utils/request';
import { deserializeSchoolyear } from '@teetsh/app/src/queries/schoolyears/serializer';

export default function getSchoolyears(
  tz: string,
  withClassrooms?: boolean,
  filterYear?: number,
) {
  const params = new URLSearchParams();
  if (withClassrooms) {
    params.append('include', 'classrooms');
  }
  if (filterYear) {
    params.append('year', filterYear.toString());
  }

  return request(`/schoolyears?${params.toString()}`, {
    method: 'GET',
  }).then(({ data }: { data: any[] }) =>
    (data || []).map(s => deserializeSchoolyear(s, tz)),
  );
}
